import { useSetRecoilState } from 'recoil'

import { requestLoadingAtom, requestAtom, requestViewStateAtom, insurerAtom, patientAtom, practiceAtom } from './requestState'

import socialHistoryAtom from 'components/forms/socialHistory/state'
import generalHistoryAtom from 'components/forms/generalHistory/state'
import laboratoryStudiesAtom from 'components/forms/laboratoryStudies/state'
import medicationsAtom from 'components/forms/medications/state'
import attachmentsAtom, { attachmentFilesAtom } from 'components/forms/attachments/state'
import conditionSpecificAtom from 'components/forms/conditionSpecific/state'
import missingInformationAtom from 'components/forms/missingInformation/state'

export default () => {
    const setRequestLoadingState = useSetRecoilState(requestLoadingAtom)
    const setRequestViewState = useSetRecoilState(requestViewStateAtom)
    const setRequestState = useSetRecoilState(requestAtom)
    const setInsurerState = useSetRecoilState(insurerAtom)
    const setPatientState = useSetRecoilState(patientAtom)
    const setPracticeState = useSetRecoilState(practiceAtom)
    const setGeneralHistoryState = useSetRecoilState(generalHistoryAtom)
    const setSocialHistoryState = useSetRecoilState(socialHistoryAtom)
    const setLaboratoryStudiesState = useSetRecoilState(laboratoryStudiesAtom)
    const setMedicationsState = useSetRecoilState(medicationsAtom)
    const setAttachmentsState = useSetRecoilState(attachmentsAtom)
    const setAttachmentsFilesState = useSetRecoilState(attachmentFilesAtom)
    const setConditionSpecificState = useSetRecoilState(conditionSpecificAtom)
    const setMissingInformationState = useSetRecoilState(missingInformationAtom)


    const setLoading = (isLoading) => setRequestLoadingState(isLoading)

    const setData = (request) => {
        // Extract view state
        if (request.viewState) {
            const viewState = JSON.parse(request.viewState)
            setRequestViewState(viewState)
        }

        // Split request details & patient data for storing in state
        const { patientData, insurer, ...requestDetails } = request

        setPracticeState(patientData.practice || {})

        // Update state for each tab
        setRequestState(requestDetails)
        setInsurerState(insurer)
        setPatientState(patientData.patient)
        setGeneralHistoryState(patientData.generalHistory)
        setSocialHistoryState(patientData.socialHistory)
        setLaboratoryStudiesState(patientData.laboratoryStudies)
        setMedicationsState(patientData.medications)
        setAttachmentsState(patientData.attachments)
        setAttachmentsFilesState(requestDetails.attachments)
        
        if (patientData.conditionSpecific.questions) {
            // Questions property is saved to database as a string value
            // We need to parse this into a JSON object when reloading
            console.log('CSQ - Parse data - before', patientData.conditionSpecific)

            patientData.conditionSpecific = {
                ...patientData.conditionSpecific,
                questions: JSON.parse(patientData.conditionSpecific.questions)
            }

            setConditionSpecificState(patientData.conditionSpecific)
        } else {
            setConditionSpecificState(patientData.conditionSpecific)
        }

        // Check if request is a Missing Information Request        
        if (request.form.type === 'MIR') {
            setMissingInformationState(patientData.missingInformation)
        }
    }

    return {
        setLoading,
        setData
    }
}